module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3Uy1uC/tc-custom/9781613765753.jpg?1726617369944",
      "alt": "This image is the cover for the book My Old Faithful, Juniper Prize for Fiction"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("My Old Faithful, Juniper Prize for Fiction\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Showing both the drama of familial intimacy and the ups and downs of the everyday, "), _c('i', [_vm._v("My Old Faithful")]), _vm._v(" introduces readers to a close-knit Chinese family. These ten interconnected short stories, which take place in China and the United States over a thirty-year period, merge to paint a nuanced portrait of family life, full of pain, surprises, and subtle acts of courage. Richly textured narratives from the mother, the father, the son, and the daughters play out against the backdrop of China's social and economic change."), _c('br'), _c('br'), _vm._v(" With quiet humor and sharp insight into the ordinary, Yang Huang writes of a father who spanks his son out of love, a brother who betrays his sister, and a woman who returns to China after many years to find her country changed in ways both expected and startling.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Yang Huang\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Massachusetts Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0